import { useFlag } from '@reflag/react-sdk';
import UploadInvestorInvestmentV1 from './UploadInvestorInvestmentV1';
import UploadInvestorInvestmentV2 from './UploadInvestorInvestmentV2';

const UploadInvestorInvestment: React.FC = () => {
  const { isEnabled: uploadsV2Enabled } = useFlag('uploads-v-2');

  if (uploadsV2Enabled) {
    return <UploadInvestorInvestmentV2 />;
  }

  return <UploadInvestorInvestmentV1 />;
};

export default UploadInvestorInvestment;
